import { TipoPeriodicidadePagamento } from '../../../services/tipos';

/**
 * Cópia da linha da grid no formato do formulário ({ value, unit } no prazo mínimo). Alterar a própria
 * linha aninhava o objeto a cada abertura e a coluna Prazo mudava sozinha (DL-164).
 */
export const prepararLocacaoParaFormulario = (row: any) => {
    let prazo = row.tempoContratoEmMeses;
    while (prazo && typeof prazo === 'object') prazo = prazo.value;
    return { ...row, tempoContratoEmMeses: { value: prazo, unit: row.tipoPeriodicidadeTempoContrato } };
};

/**
 * Distância entre hoje e hoje + diffDias em meses de calendário e dias. Meses fixos de 30 dias faziam
 * um contrato de exatamente 3 meses aparecer como "3 meses e 2d" (DL-164).
 */
export const separarEmMesesEDias = (diffDias: number, hojeRef: Date = new Date()): { meses: number; dias: number } => {
    const inicio = new Date(hojeRef);
    inicio.setHours(0, 0, 0, 0);
    const alvo = new Date(inicio);
    alvo.setDate(alvo.getDate() + diffDias);
    const [de, ate] = diffDias >= 0 ? [inicio, alvo] : [alvo, inicio];
    const somarMeses = (base: Date, n: number) => {
        // Igual ao AddMonths do .NET: 31/01 + 1 mês é 28/02.
        const d = new Date(base.getFullYear(), base.getMonth() + n, 1);
        const ultimoDia = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
        d.setDate(Math.min(base.getDate(), ultimoDia));
        return d;
    };
    let meses = 0;
    while (somarMeses(de, meses + 1) <= ate) meses++;
    const dias = Math.round((ate.getTime() - somarMeses(de, meses).getTime()) / (1000 * 60 * 60 * 24));
    return { meses, dias };
};

/**
 * Fim do prazo contratado: início da locação mais o prazo mínimo, na unidade escolhida na criação, como o
 * contrato em PDF calcula no backend (LocacaoService.CalcularDataEncerramento). A data de pagamento é só o
 * vencimento da parcela: numa diária com pagamento único vencendo no último dia, somar o prazo a ela
 * mostrava o dobro do contrato (DL-203).
 */
export const calcularFimDoPrazoContratado = (row: any): Date | null => {
    // A edição troca o campo da linha por { value, unit }: aceitar os dois formatos.
    const prazoBruto = row.tempoContratoEmMeses;
    const prazo = Number(prazoBruto && typeof prazoBruto === 'object' ? prazoBruto.value : prazoBruto) || 0;
    const base = row.dataInicio || row.dataPagamento;
    if (prazo <= 0 || !base) return null;
    const fim = new Date(base);
    if (isNaN(fim.getTime())) return null;
    switch (row.tipoPeriodicidadeTempoContrato) {
        case TipoPeriodicidadePagamento.Mensal: {
            // Igual ao AddMonths do .NET: 31/01 + 1 mês é 28/02, não 03/03.
            const dia = fim.getDate();
            fim.setDate(1);
            fim.setMonth(fim.getMonth() + prazo);
            fim.setDate(Math.min(dia, new Date(fim.getFullYear(), fim.getMonth() + 1, 0).getDate()));
            break;
        }
        case TipoPeriodicidadePagamento.Semanal: fim.setDate(fim.getDate() + prazo * 7); break;
        case TipoPeriodicidadePagamento.Quinzenal: fim.setDate(fim.getDate() + prazo * 15); break;
        default: fim.setDate(fim.getDate() + prazo);
    }
    return fim;
};
